var exports = {
  "f5": "xaf9ae18d--362283--building-icon",
  "vu": "xaf9ae18d--362283--active",
  "lq": "xaf9ae18d--362283--viewed",
};

module.exports = exports;
